module.exports = __webpack_public_path__ + "static/site-1748617940196/img/getnet-logo.f8582d56.png";